import { LogoConfig } from '../../models/logo-config/logo-config.model';
import { LOGO } from './logo.token';

export const provideLogo = (config?: LogoConfig) => [
    {
        provide: LOGO,
        useValue: config,
    },
];
